import { useEffect, useState } from 'react'

import { Button, Dialog, Embed } from '@/ui'
import { postCreateGustoFlow, WORKERS_COMP_FLOW } from '../payrollActions'
import { useAnalyticsTrack, useAnalyticsView } from '@/features/amplitude'
import { useAppDispatch } from '@/utils/typeHelpers'

export const WorkersCompPanel = ({ buttonText }: { buttonText: string }) => {
  const dispatch = useAppDispatch()
  const [link, setLink] = useState('')
  const [isOpen, setIsOpen] = useState(false)
  const pageView = useAnalyticsView()
  const track = useAnalyticsTrack()
  const screenName = 'payroll enroll wc'
  useEffect(() => {
    pageView(screenName)
  }, [pageView])

  useEffect(() => {
    const fetch = async () => {
      const res = await postCreateGustoFlow(WORKERS_COMP_FLOW)(dispatch)

      if (res) {
        setLink(res.url)
      }
    }

    fetch()
  }, [dispatch])

  const trackEnrollment = () => {
    track('payroll enroll wc clicked')
  }

  if (!link) {
    return null
  }

  return (
    <div className="w-full">
      <Button
        onClick={() => {
          setIsOpen(true)
          trackEnrollment()
        }}
        className="w-full"
      >
        {buttonText || 'Get Started'}
      </Button>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <Dialog.Content className="w-full h-screen max-w-none p-0">
          <Embed
            src={link ?? ''}
            scrolling
            title="Workers Compensation Enrollment"
            className="h-[90%]"
          />
        </Dialog.Content>
      </Dialog>
    </div>
  )
}
